import React from 'react'
import { Status, STATUS_VARIANTS } from '@LTIDashboard/modules/common'

export function Student({ data, index }) {
  const statuses = [
    STATUS_VARIANTS['LtiLaunch'][
      data.lti_status.launch === 'true' ? 'ok' : 'error'
    ],
    STATUS_VARIANTS['scorePosted'][
      data.lti_status.score_posted === 'true'
        ? 'ok'
        : data.activity.finished_attempts > 0
        ? 'error'
        : 'neutral'
    ],
  ]
  return (
    <tr>
      <td>{index}</td>
      <td>
        <h5>
          {data.user.last_name}, {data.user.first_name}
        </h5>
      </td>
      <td>
        {data.activity.finished_attempts} submitted
        <br />
        {data.activity.started_attempts > 0
          ? <small>{`${data.activity.started_attempts} started`}</small>
          : ''}
      </td>
      <td>
        {data.activity.finished_attempts > 0
          ? `${data.activity.points_received} / ${data.activity.points_available}`
          : 'None'}
      </td>
      <td>
        {statuses.map(item => {
          return <Status key={item.text} item={item} />
        })}
      </td>
    </tr>
  )
}
